import React from 'react';
import {Table as BaseTable} from 'desktop/sports/golf/players-list/tiers';

class Table extends BaseTable {}

export {Table};
